import { useMemo } from 'react';

const getHash = (testUrl: string) => {
  const [, hash] = testUrl?.split('.com')[1].split('?')[0]?.split('#');
  return hash ? `#${hash}` : '';
};

export const getCurrentLocation = (testUrl?: string) => {
  const params = new URLSearchParams(window.location.search);
  const __testUrl = testUrl || params.get('testUrl');

  return !!__testUrl
    ? ({
        origin: __testUrl?.split('.com')[0].concat('.com'),
        pathname: __testUrl?.split('.com')[1].split('?')[0]?.split('#')?.[0],
        hash: getHash(__testUrl),
        host: __testUrl?.split('//')?.[1]?.split('/')?.[0],
        href: __testUrl,
      } as Location)
    : window.location;
};

export const useCurrentLocation = (testUrl?: string) => {
  return useMemo(() => getCurrentLocation(testUrl), [testUrl]);
};
